import React, { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [items, setItems] = useState([]);

  const addNotification = useCallback((notification) => {
    const id = notification.id || `flash-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    const duration = notification.duration === undefined ? 8000 : notification.duration;
    setItems((prev) => [...prev, { ...notification, id, dismissible: notification.dismissible !== false }]);
    if (duration !== null) {
      setTimeout(() => {
        setItems((prev) => prev.filter((item) => item.id !== id));
      }, duration);
    }
    return id;
  }, []);

  const removeNotification = useCallback((id) => {
    setItems((prev) => prev.filter((item) => item.id !== id));
  }, []);

  const success = useCallback(
    (content, header = 'Success') => addNotification({ type: 'success', header, content }),
    [addNotification]
  );

  const error = useCallback(
    (content, header = 'Error') => addNotification({ type: 'error', header, content }),
    [addNotification]
  );

  const warning = useCallback(
    (content, header = 'Warning') => addNotification({ type: 'warning', header, content }),
    [addNotification]
  );

  const info = useCallback(
    (content, header = 'Info') => addNotification({ type: 'info', header, content }),
    [addNotification]
  );

  return (
    <NotificationContext.Provider
      value={{ items, setItems, addNotification, removeNotification, success, error, warning, info }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    throw new Error('useNotifications must be used within NotificationProvider');
  }
  return ctx;
}
